import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import useAppContext from "../../../../utils/Reducers";

const ImcomingPop = ({ importData, onClose }) => {
  //차량 검색 URL
  //공통코드 검색 URL
  //console.log(importData);
  const {
    store: { userInfo },
  } = useAppContext();

  const SEARCH_CODE_URL = "/common/code/searchDetailCode.do";
  const [scrapAreaCd, setScrapAreaCd] = useState("");
  const [menuTab, setMenuTab] = useState("grade");
  const [show, setShow] = useState(true);
  const [hide, setHide] = useState(false);
  const handleClose = (returnData) => {
    onClose();
    setShow(false);
  };

  //추가, 수정일때 항목의 disabled 결정
  const disabledFields = {
    created: [""],
    updated: ["systemCd"],
  };

  const initItem = {
    systemCd: importData.systemCd,
    inspNo: importData.wssId,
    wssId: importData.wssId,
    plantNm: importData.plantNm,
    vhclNo: importData.vhclNo,
    inspRmks: importData.inspRmks,
    inWeight: importData.inWeight,
    inptDt: importData.inptDt,
    outptDt: importData.outptDt,
    outWeight: importData.outWeight,
    realWght: importData.realWght,
    scrapAreaCdNm: importData.scrapAreaCdNm,
    totalWeight: importData.totalWeight,
    itemCd: importData.itemCd,
    itemNm: importData.itemNm,
    vndrCd: importData.vndrCd,
    vndrNm: importData.vndrNm,
    tmsOdrNo: importData.tmsOdrNo,

    returnCnt: importData.returnCnt,
  };

  const [state, setState] = useState("created");

  const [fieldValues, setFieldValues] = useState(initItem);
  if (importData.inspNo === "" || importData.inspNo === null) {
    importData.outageWght = "";
  }
  useEffect(() => {
    //setFieldValues(initItem);
  }, []);

  const onHide = () => {
    setHide(!hide);
  };

  const onMenuTab = (menuNm) => {
    setMenuTab(menuNm);
  };
  return (
    <>
      <Modal
        className="modal-fullscreen-md-down ims orenges"
        show={show}
        onHide={() => handleClose(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {importData.wssId === "" || importData.wssId === null
              ? importData.inspNo
              : importData.wssId}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={hide ? "infotype on" : "infotype"} onClick={onHide}>
            <div>
              <div className="micon trans">
                <div></div>
                <p>차량번호</p>
              </div>
              <div className="inf">
                <div>
                  <h3>
                    {fieldValues.vhclNo} / {fieldValues.plantNm}
                  </h3>
                </div>
              </div>
            </div>
            <div>
              <div className="micon time">
                <div></div>
                <p>입차일시</p>
              </div>
              <div className="inf">
                <div>
                  <h3>
                    {fieldValues.inptDt} / {fieldValues.scrapAreaCdNm}
                  </h3>
                </div>
              </div>
            </div>
            <div>
              <div className="micon box">
                <div></div>
                <p>입차중량</p>
              </div>
              <div className="inf">
                <div>
                  <h3>{fieldValues.inWeight}kg</h3>
                </div>
              </div>
            </div>
          </div>
          <ul className="mlist">
            <li className="head">
              <div>사전등급</div>
            </li>
            <li className="fullsc">
              <div>{fieldValues.itemNm}</div>
            </li>
            <li className="head">
              <div>검수원비고</div>
            </li>
            <li className="fullsc">
              <div>{fieldValues.inspRmks}</div>
            </li>
            <li className="head">
              <div>차량정보</div>
            </li>
            <li className="fullsc">
              <div>{fieldValues.vhclNo}</div>
            </li>

            <li className="head">
              <div>업체정보</div>
            </li>
            <li className="fullsc">
              <div>{fieldValues.vndrNm}</div>
            </li>
            <li className="head">
              <div>하차지</div>
            </li>
            <li className="fullsc">
              <div>{fieldValues.scrapAreaCdNm}</div>
            </li>
          </ul>
        </Modal.Body>
      </Modal>
    </>
  );
};

export const ModalImcomingPop = createModal(ImcomingPop);

export default ImcomingPop;
